<template>
  <div>
    <ManagerBar />
    <router-view></router-view>
  </div>
</template>

<script>
import ManagerBar from "@/components/navigation-bar/ManagerBar";
export default {
  components: {
    ManagerBar,
  },
};
</script>
